const PROGUIDES_WEB_URL = process.env.PROGUIDES_WEB_URL
const INSTAPRO_API_URL = process.env.INSTAPRO_API_URL
const AIMLABS_HASURA_API_URL = process.env.AIMLABS_HASURA_API_URL

export const BASE_URL = `${PROGUIDES_WEB_URL}api/v2/`
export const INSTAPRO_BASE_URL = `${INSTAPRO_API_URL}api/v1/`
export const AIMLABS_HASURA_GRAPHQL_ENDPOINT = `${AIMLABS_HASURA_API_URL}/v1/graphql`



// WEBPACK FOOTER //
// ./src/constants/util.js